import { useEffect, useRef, useState } from 'react';

export default function NationwideShipping() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Fully Insured',
      description: 'Every vehicle is covered with comprehensive insurance during transit.',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Delivery',
      description: 'Most deliveries completed within 7-14 business days nationwide.',
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Door-to-Door',
      description: 'We deliver directly to your home or preferred location.',
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 sm:py-28 px-4 sm:px-8 lg:px-16 bg-[#111111]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12 bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs tracking-[0.4em] uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Nationwide Delivery
            </span>
            <div className="h-px w-12 bg-[#C9A84C]"></div>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            We Ship to 48 States
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-sm leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}>
            We ship vehicles across the contiguous 48 states. Our trusted transport partners ensure your vehicle arrives safely, on time, and ready to drive — no matter where you are in the continental United States.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`bg-[#0d0d0d] border border-white/5 p-6 rounded-sm hover:border-[#C9A84C]/40 transition-all duration-700 hover:shadow-xl hover:shadow-[#C9A84C]/5 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm mb-5">
                <i className={`${feature.icon} text-[#C9A84C] text-2xl`}></i>
              </div>
              <h3 className="text-white text-base font-semibold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {feature.title}
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}